import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from '../notification.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'bidi-notification-launcher',
  templateUrl: './notification-launcher.component.html',
  styleUrls: ['./notification-launcher.component.scss']
})
export class NotificationLauncherComponent implements OnInit {
  unread$: Observable<number>;

  constructor (private notifications: NotificationService) {
  }

  ngOnInit () {
    this.unread$ = this.notifications.unread$;
  }
}
